<mat-toolbar class="toolbar no-print">
  <button mat-icon-button (click)="sidenav.toggle()"><mat-icon>menu</mat-icon></button>
  <div style="padding: 8px;">
    <a style="color:white;" href="">Home</a>
  </div>
  @if (onCallEnabled) {
    <span style="color:#0093a1">|</span>
    <div style="padding: 8px;">
      <a style="color:white;" href="oncall">OnCall</a>
    </div>
  }
  <span style="color:#0093a1">|</span>
  <div style="padding: 8px;">
    <a style="color:white;" href={{mdpUrl}}>Catalog</a>
  </div>
  <span style="color:#0093a1">|</span>
  <div style="padding: 8px;">
    <a style="color:white;" [href]="graphUrl" target="_blank" rel="noopener noreferrer">Graph</a>
  </div>
  <span style="color:#0093a1">|</span>
  <div style="padding: 8px;">
    <a style="color:white;" href="https://platform-documentation-79y.pages.dev/">Platform Docs</a>
  </div>
  <span class="toolbar-spacer"></span>
  <button
    mat-icon-button
    matTooltip="User Profile"
    color="accent"
    routerLink="me">
    <mat-icon>manage_accounts</mat-icon>
  </button>
  @if (isAuthenticated) {
    <app-impersonate-user></app-impersonate-user>
  }
</mat-toolbar>
<mat-sidenav-container hasBackdrop class="sidenav-container">
  <mat-sidenav
    [autoFocus]="false"
    [fixedInViewport]="mobileQuery.matches"
    #sidenav
    style="background-color: black; padding-left: 0; padding-right: 0;"
    ><br/><br/><br/>
    <div>
      <div style="text-align: center">
        <img src="../assets/adesa.png" alt="adesa" style="display: block; margin: 0 auto; max-width: 100%; height: auto; margin-top: -50px;"/><br><br>
        <mat-divider
          [inset]="false"
        ></mat-divider>

        <mat-divider
          [inset]="false"
        ></mat-divider>
        @if (!isAuthenticated) {
          <div id="loginprompt">
            <a href="#" (click)="loginRedirect()"
              ><h3
              style="
                margin: 3px;
                font: 400 16px/28px Cascadia Code PL, Roboto, Helvetica Neue,
                  sans-serif;
                color: white;
              "
              >
              Login
            </h3></a
            >
          </div>
        }
        @if (isAuthenticated) {
          <div>
            <h3
            style="
              margin: 3px;
              font: 400 16px/28px Cascadia Code PL, Roboto, Helvetica Neue,
                sans-serif;
            "
              >
              {{ userName }}
            </h3>
          </div>
        }
      </div>

      <mat-divider
        [inset]="false"
      ></mat-divider>

      <mat-divider
        [inset]="false"
      ></mat-divider>
      @if (!isOnCallModule) {
        <app-navmenu></app-navmenu>
      }
      @if (isOnCallModule) {
        <app-oncall-navmenu></app-oncall-navmenu>
      }
    </div>
  </mat-sidenav>
  <mat-sidenav-content style="margin-left:0">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-spinner></app-spinner>
